<template>
  <CardInfo title="Posts" class="information__post" :show-title="showTitle">
    <template v-slot:above-title>
      <h3 class="mb-4 font-weight-bold"></h3>
    </template>

    <template v-slot:below-title>
      <div v-if="posts">
        <!-- section detail -->
        <ListSession
          v-if="section"
          :section="section"
          :learning-unit="learningUnit"
          :show-code="false"
          :show-enroll="false"
          :show-manage-button="false"
          :show-actions="false"
          :show-timezone="true"
          :show-title-as-link="false"
          :col-row="12"
          editable
          class="section_detail pb-5 mt-5"
        />

        <!-- post list -->
        <post-list-item
          v-for="(post, index) in posts"
          :key="`post__list-item--${index}`"
          :learning-unit="learningUnit"
          :post="post"
          :post-schedule="getPostSchdule(post.id)"
          :section="section"
          :show-badge="false"
          :show-date="false"
          :show-options="false"
          class="list_post mt-4 ml-3"
        >
        </post-list-item>
      </div>
    </template>
  </CardInfo>
</template>

<script>
import CardInfo from './CardInfo';
// import PublishDisplay from "@/views/Post/components/PublishDisplay";
import ListSession from '@/views/Section/components/ListSession.vue';
import Section from '@/models/Section';
import LearningUnit from '@/models/LearningUnit';
import PostSchedule from '@/models/PostSchedule';
import { datetimeMixin } from '@/mixins/datetimeMixin';
import PostListItem from '@/components/Post/PostListItem';

export default {
  name: 'PostList',

  components: {
    CardInfo,
    // PublishDisplay,
    ListSession,
    PostListItem
  },

  mixins: [datetimeMixin],

  props: {
    section: {
      type: Section,
      reqiured: true,
      default: null
    },

    posts: {
      type: Array,
      default: () => []
    },

    showTitle: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    learningUnitId() {
      return parseInt(this.$route.params.learningUnitId);
    },

    learningUnit() {
      return LearningUnit.query().where('id', this.learningUnitId).first();
    },

    postSchedule() {
      return PostSchedule.query().where('section_id', this.section.id).get();
    }
  },

  methods: {
    getPostSchdule(postId) {
      return PostSchedule.query()
        .where('section_id', this.section.id)
        .where('post_id', postId)
        .first();
    }
  }
};
</script>

<style lang="scss">
.information__post {
  .list_post {
    border-bottom: 1px solid rgba(7, 9, 25, 0.125);
    height: 128px;
  }

  .section_detail {
    border-bottom: 1px solid rgba(7, 9, 25, 0.125);
  }

  .img-content {
    min-width: 160px;
    max-width: 160px;
    height: 90px;
    border-radius: 10.4px;
  }

  .post__list-item-content {
    margin-bottom: 1rem;
    justify-content: start !important;
  }

  .post__title {
    margin-bottom: 0.5rem;
  }

  .container__section-info {
    width: 100%;
    display: flex;
    justify-content: center;

    .section__date-time,
    .meeting {
      width: 47.5%;
    }

    .section__date-time {
      white-space: normal;
    }

    .text__session-time {
      font-size: 1.1875rem;
      padding-top: 0.25rem;
    }

    .text__session-last-enrollment-date {
      padding-top: 0.5rem;
    }
  }
}
</style>
